export default "/_next/static/images/ae9e6877e5dec847fd242113c044185f.png";